import { useIsAdmin } from 'hooks/useRoleCheck';
import { useEPDCommentLog } from 'services/api/queries';

/**
 * The Comment Log button is visible only to Super Admins and only when at least
 * one comment log record exists for the EPD.
 */
export function useShowEPDCommentLogButton(epdId: string): boolean {
  const isAdmin = useIsAdmin();
  const { data } = useEPDCommentLog(epdId, isAdmin && !!epdId);
  return isAdmin && !!data?.items?.length;
}
